export default __webpack_public_path__ + "static/media/S2xCLUE1.fb3c8ae4.jpg";